// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-pagination {
  position: sticky;
  z-index: 10;
  background: var(--background-color, #ffffff);
  border-radius: 8px;
  margin: 8px;
}

.timeline-pagination__top {
  display: flex;
  justify-content: center;
  padding: 8px;
  border-bottom: 1px solid var(--border-color, #e0e0e0);
}

.timeline-pagination__bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  gap: 4px;
}

.timeline-pagination__button {
  background: var(--accent-color, #2196f3);
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.timeline-pagination__button:hover {
  background: var(--accent-color-dark, #1976d2);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.timeline-pagination__button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.timeline-pagination__button--backward {
  background: var(--secondary-color, #ff9800);
}

.timeline-pagination__button--backward:hover {
  background: var(--secondary-color-dark, #f57c00);
}

.timeline-pagination__button--forward {
  background: var(--primary-color, #4caf50);
}

.timeline-pagination__button--forward:hover {
  background: var(--primary-color-dark, #388e3c);
}

.timeline-pagination__button--live {
  background: var(--accent-color, #2196f3);
  animation: pulse 2s infinite;
}

.timeline-pagination__button--live:hover {
  background: var(--accent-color-dark, #1976d2);
  animation: none;
}

.timeline-pagination__loading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary, #666666);
  font-size: 14px;
}

.timeline-pagination__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--border-color, #e0e0e0);
  border-top: 2px solid var(--accent-color, #2196f3);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.timeline-pagination__indicator {
  text-align: center;
  padding: 4px 8px;
  background: var(--background-secondary, #f5f5f5);
  border-radius: 12px;
  margin-top: 4px;
}

.timeline-pagination__position {
  font-size: 12px;
  color: var(--text-secondary, #666666);
  font-style: italic;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Dark theme support */
@media (prefers-color-scheme: dark) {
  .timeline-pagination {
    background: var(--background-color-dark, #1e1e1e);
  }
  
  .timeline-pagination__top {
    border-bottom-color: var(--border-color-dark, #333333);
  }
  
  .timeline-pagination__loading {
    color: var(--text-secondary-dark, #cccccc);
  }
  
  .timeline-pagination__position {
    color: var(--text-secondary-dark, #cccccc);
  }
  
  .timeline-pagination__indicator {
    background: var(--background-secondary-dark, #2a2a2a);
  }
  
  .timeline-pagination__spinner {
    border-color: var(--border-color-dark, #333333);
    border-top-color: var(--accent-color, #2196f3);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .timeline-pagination {
    margin: 4px;
  }
  
  .timeline-pagination__button {
    padding: 6px 12px;
    font-size: 13px;
  }
  
  .timeline-pagination__loading {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TimelinePagination.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,kDAAkD;EAClD,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,iDAAiD;EACnD;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,+CAA+C;IAC/C,8CAA8C;EAChD;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".timeline-pagination {\n  position: sticky;\n  z-index: 10;\n  background: var(--background-color, #ffffff);\n  border-radius: 8px;\n  margin: 8px;\n}\n\n.timeline-pagination__top {\n  display: flex;\n  justify-content: center;\n  padding: 8px;\n  border-bottom: 1px solid var(--border-color, #e0e0e0);\n}\n\n.timeline-pagination__bottom {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px;\n  gap: 4px;\n}\n\n.timeline-pagination__button {\n  background: var(--accent-color, #2196f3);\n  color: white;\n  border: none;\n  border-radius: 20px;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.timeline-pagination__button:hover {\n  background: var(--accent-color-dark, #1976d2);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.timeline-pagination__button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.timeline-pagination__button--backward {\n  background: var(--secondary-color, #ff9800);\n}\n\n.timeline-pagination__button--backward:hover {\n  background: var(--secondary-color-dark, #f57c00);\n}\n\n.timeline-pagination__button--forward {\n  background: var(--primary-color, #4caf50);\n}\n\n.timeline-pagination__button--forward:hover {\n  background: var(--primary-color-dark, #388e3c);\n}\n\n.timeline-pagination__button--live {\n  background: var(--accent-color, #2196f3);\n  animation: pulse 2s infinite;\n}\n\n.timeline-pagination__button--live:hover {\n  background: var(--accent-color-dark, #1976d2);\n  animation: none;\n}\n\n.timeline-pagination__loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-secondary, #666666);\n  font-size: 14px;\n}\n\n.timeline-pagination__spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--border-color, #e0e0e0);\n  border-top: 2px solid var(--accent-color, #2196f3);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.timeline-pagination__indicator {\n  text-align: center;\n  padding: 4px 8px;\n  background: var(--background-secondary, #f5f5f5);\n  border-radius: 12px;\n  margin-top: 4px;\n}\n\n.timeline-pagination__position {\n  font-size: 12px;\n  color: var(--text-secondary, #666666);\n  font-style: italic;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n/* Dark theme support */\n@media (prefers-color-scheme: dark) {\n  .timeline-pagination {\n    background: var(--background-color-dark, #1e1e1e);\n  }\n  \n  .timeline-pagination__top {\n    border-bottom-color: var(--border-color-dark, #333333);\n  }\n  \n  .timeline-pagination__loading {\n    color: var(--text-secondary-dark, #cccccc);\n  }\n  \n  .timeline-pagination__position {\n    color: var(--text-secondary-dark, #cccccc);\n  }\n  \n  .timeline-pagination__indicator {\n    background: var(--background-secondary-dark, #2a2a2a);\n  }\n  \n  .timeline-pagination__spinner {\n    border-color: var(--border-color-dark, #333333);\n    border-top-color: var(--accent-color, #2196f3);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .timeline-pagination {\n    margin: 4px;\n  }\n  \n  .timeline-pagination__button {\n    padding: 6px 12px;\n    font-size: 13px;\n  }\n  \n  .timeline-pagination__loading {\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
